import * as endpoints from "./backend.config";
import store from "../../store";
// import menuData from "@/services/compiler/menu"
import schemaData from "@/services/compiler/schema"
import regData from "@/services/compiler/registration"

import {ref} from "vue";
import { deauthenticate } from "../user/user.service";

// @ts-ignore
const useHardcodedValues = process.env.VUE_APP_USE_HARDCODED_VALUES === 'TRUE';

export async function getMenuData(
  componentId: string,
  elementId: string | null
) {
  try {
    const response = ref([]);
    if(elementId != null) {
    response.value = await fetchGet(
      endpoints.MENU + componentId + "/" + elementId
    );
  } else {
    response.value = await fetchGet(
      endpoints.MENU + componentId)
  }

    return response;
  } catch {
    if (process.env.NODE_ENV !== "production") {
      console.error("failed to fetch menu");
    } else {
      deauthenticate();
    }
    return [];
  }
}

export async function logout() {
  const response = await fetchGet(endpoints.LOGOUT);

  return response;
}

export async function translate(data: unknown) {
  const response = await fetchPost(endpoints.TRANSLATION, JSON.stringify(data));
  return response;
}

export async function getResourceData(data: string) {
  if (data != "") {
    const response = await fetchGetData(endpoints.RESOURCE + data);
    return response;
  } else {
    return [];
  }
}

export async function getResourceDetailData(data: string) {
  const response = await fetchGetData(endpoints.RESOURCEDETAIL + data);
  return response;
}

export async function getSchema() {
  const response = useHardcodedValues ? schemaData : await fetchGetData(endpoints.SCHEMA);
  return response;
}

export async function addNewResource(data: unknown) {
  const response = await fetchPostJson(endpoints.CREATERESOURCE, data);
  return response;
}
export async function getComponentRoute(componentId: string) {
  try {
    const response = await fetchGet(endpoints.COMPONENT_ROUTE + componentId);

    return response;
  } catch {
    // @ts-ignore
    if (process.env.NODE_ENV !== "production") {
      console.error("failed to fetch routes");
    } else {
      //deauthenticate();
    }
    return [];
  }
}


export async function fetchAzureUsers() {
  const response = await fetchGet(endpoints.USERS);

  return response;
}

export async function fetchHarnessUsers(data: unknown) {
  const response = await fetchPostJsonHarness(
    "https://cors.redoc.ly/https://app.harness.io/ng/api/user/aggregate?accountIdentifier=FySwSK-YRI6D8KCbkvGMxg",
    "pat.FySwSK-YRI6D8KCbkvGMxg.64d4855da367455763e77bcc.fnlo9Hpt9Poa0aTeEfT8",
    data
  );
  return response;
}

export async function fetchHarnessLog(
  startTime: number,
  endTime: number,
  pageIndex: number
) {
  const data = {
    scopes: [
      {
        accountIdentifier: "FySwSK-YRI6D8KCbkvGMxg",
      },
    ],
    actions: ["ADD_COLLABORATOR", "REMOVE_COLLABORATOR"],
    staticFilter: "EXCLUDE_LOGIN_EVENTS",
    startTime: startTime,
    endTime: endTime,
    filterType: "Audit",
  };
  const response = await fetchPostJsonHarness(
    "https://cors.redoc.ly/https://app.harness.io/audit/api/audits/list?accountIdentifier=FySwSK-YRI6D8KCbkvGMxg&pageIndex=" +
      pageIndex.toString() +
      "&pageSize=100",
    "pat.FySwSK-YRI6D8KCbkvGMxg.64d4855da367455763e77bcc.fnlo9Hpt9Poa0aTeEfT8",
    data
  );
  return response;
}

export async function getEntityData(secret?: any) {
  const response = await fetchEntityId(
    endpoints.ENTITY_ID,
    secret ? secret : null
  );
  return response;
}
export async function getEntities(requestJson: any) {
  const url = `${endpoints.ENTITIES}`;

  const response = await fetchPost(url, requestJson);

  if (!response) {
    return false;
  }

  return response.data;
}
export async function getRegistrationForm(
) {
  const response = await fetchGet(
    endpoints.REGISTRATION_FORM
  );

  return response;
}

export async function getToolTips() {
  const response = await fetchGet(`${endpoints.TOOLTIPS}`);
  return response;
}

export async function registerUser(data: any) {
  const response = await fetchPost(endpoints.REGISTRATION, data);
  return response;
}

export async function saveSyncEvent() {
  console.log("here should be saved sync event");
  //const response = await fetchPost(endpoints.SYNC_EVENT, 'FySwSK-YRI6D8KCbkvGMxg');
  //return response;
}

export async function fetchEntityId(url: string, secret?: any) {
  if (secret && secret != "") {
    const response = await fetch(url + "/" + secret);
    return await response.json();
  } else {
    const response = await fetch(url);
    return await response.json();
  }
}

export async function fetchGet(url: string) {
  const response = await fetch(url, { credentials: "include" });
  if (!response.ok) {
    if (process.env.NODE_ENV !== "production") {
      console.error(response.statusText);
    } else {
      deauthenticate();
    }

    store.commit("showWarningModal", true);
    return [];
  }

  return await response.json();
}
export async function fetchPost(url: string, data: any) {
  const response = await fetch(url, {
    method: "POST",
    credentials: "include",
    body: data,
  });
  return await response.json();
}
async function fetchGetData(url: string) {
  const response = await fetch(url, { credentials: "include" })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.log("error", error);
      throw new Error("Error getting data");
    });
  return response;
}

async function fetchPostJson(url: string, data: unknown) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function fetchPostJsonHarness(url: string, token: string, data: unknown) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": token,
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
